import { Settings } from 'react-slick'
import { ReactNode } from 'react'
import styles from '@/components/SliderPromotions/SliderPromotions.module.scss'
import { PartnerPromotion } from '@/store/slices/stagesSlice/interfaces'

export const adaptiveText = (text: string) => {
  let lines = text.split(/\r?\n/)

  return (
    <>
      {lines.map((line, index, arr) => (
        <span key={index}>
          {line}
          {index < arr.length - 1 && <br />}
        </span>
      ))}
    </>
  )
}

export const sliderSettings = (
  partnerPromotions: PartnerPromotion[] | null,
  onSwipe?: () => void,
): Settings => ({
  dots: !!partnerPromotions?.length,
  arrows: false,
  infinite: !!partnerPromotions?.length,
  autoplay: true,
  autoplaySpeed:
    partnerPromotions && partnerPromotions[0]?.scroll_speed ? partnerPromotions[0].scroll_speed * 1000 : 3000,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  swipe: !!partnerPromotions?.length,
  touchThreshold: 10,
  swipeEvent: onSwipe,
  customPaging(): ReactNode {
    return <button className={styles.sliderDot} />
  },
})
